<template>
  <symbol
    id="pin-spot-dome"
    viewBox="0 0 72.17 80.26"
  >
    <g>
      <path
        d="M365.573,289.107a36.083,36.083,0,1,0-33.253,38.707,36.083,36.083,0,0,0,33.253-38.707"
        transform="translate(-293.508 -255.749)"
      />
      <path
        d="M359.245,298.933a29.346,29.346,0,0,0-29.051-29.344,29.663,29.663,0,0,0-29.639,29.133,29.354,29.354,0,0,0,18.973,27.669,14.886,14.886,0,0,1,5.64,3.847,60.953,60.953,0,0,1,4.225,5.494.675.675,0,0,0,1.063.036c1.646-1.965,3.336-4.21,5.062-6a15.075,15.075,0,0,1,5.241-3.566,29.356,29.356,0,0,0,18.486-27.269"
        transform="translate(-293.508 -255.749)"
      />
      <path
        d="M358.5,292.277a28.48,28.48,0,1,0-28.48,28.48,28.48,28.48,0,0,0,28.48-28.48"
        transform="translate(-293.508 -255.749)"
        fill="#fff"
      />
    </g>
    <g transform="translate(-293.508 -255.749)">
      <path d="M336.541,306.639H323.764a.692.692,0,0,1-.221-.037L313.1,302.951a.671.671,0,0,1-.354-.288l-3.723-6.2a.669.669,0,0,1-.072-.517l2.92-10.951a.662.662,0,0,1,.224-.345l7.154-5.841a.676.676,0,0,1,.175-.1l10.441-4.161a.669.669,0,0,1,.5,0l10.074,4.162a.665.665,0,0,1,.161.094l7.447,5.913a.673.673,0,0,1,.228.344l2.92,10.44a.668.668,0,0,1-.073.529l-3.8,6.205a.673.673,0,0,1-.323.273l-10.221,4.089A.684.684,0,0,1,336.541,306.639ZM323.878,305.3h12.534l9.9-3.959,3.528-5.767-2.783-9.95-7.2-5.721-9.737-4.022L320.019,279.9l-6.907,5.639-2.792,10.468,3.453,5.756Z" />
      <path d="M350.559,296.344a.67.67,0,0,1-.567-.312l-3.869-6.132-6.106-9.87-9.962-.918a.669.669,0,0,1-.608-.666v-3.285a.669.669,0,0,1,1.338,0v2.675l9.687.893a.668.668,0,0,1,.507.314l6.278,10.148,3.867,6.127a.669.669,0,0,1-.565,1.026Z" />
      <path d="M336.54,306.639a.661.661,0,0,1-.269-.057.669.669,0,0,1-.343-.882l4.408-10.024-4.29-9.706-6.2-6.83-9.772.82-9.9,16.282a.669.669,0,0,1-1.144-.7L319.1,278.974a.671.671,0,0,1,.516-.319l10.44-.876a.67.67,0,0,1,.551.217l6.5,7.155a.684.684,0,0,1,.117.179l4.453,10.075a.665.665,0,0,1,0,.539l-4.526,10.3A.672.672,0,0,1,336.54,306.639Z" />
      <path d="M323.765,306.639a.671.671,0,0,1-.613-.4L318.7,296.165a.671.671,0,0,1,0-.543l4.6-10.294a.686.686,0,0,1,.105-.166l6.206-7.155a.669.669,0,0,1,1.011.877l-6.141,7.08-4.438,9.932,4.333,9.8a.67.67,0,0,1-.341.883A.682.682,0,0,1,323.765,306.639Z" />
      <path d="M341.067,296.563H319.311a.67.67,0,0,1-.49-.213l-5.767-6.205a.666.666,0,0,1-.163-.309l-1.022-4.526a.669.669,0,0,1,1.305-.295l.982,4.351,5.447,5.86h21.163l5.307-6,.911-4.138a.669.669,0,0,1,1.307.288l-.949,4.308a.668.668,0,0,1-.153.3l-5.621,6.352A.671.671,0,0,1,341.067,296.563Z" />
      <path d="M313.479,302.693a.65.65,0,0,1-.245-.046.667.667,0,0,1-.424-.614l-.155-12.336a.67.67,0,0,1,.428-.632l10.586-4.088a.67.67,0,0,1,.242-.045h12.7a.651.651,0,0,1,.243.046l10.075,3.942a.668.668,0,0,1,.425.624l-.018,12.113a.669.669,0,0,1-1.157.456l-5.6-5.98a.669.669,0,1,1,.976-.915L346,299.967l.016-9.968-9.532-3.729H324.035L314,290.146l.128,10.227,4.7-4.939a.668.668,0,0,1,.969.921l-5.833,6.13A.666.666,0,0,1,313.479,302.693Z" />
      <path d="M323.983,306.639a.669.669,0,0,1-.568-1.021l16.426-26.575a.669.669,0,1,1,1.138.7l-16.427,26.574A.667.667,0,0,1,323.983,306.639Z" />
      <path d="M336.562,306.581a.668.668,0,0,1-.566-.311l-16.821-26.561a.669.669,0,0,1,1.13-.716l16.821,26.562a.668.668,0,0,1-.564,1.026Z" />
    </g>
  </symbol>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// dome.vue?0effb14e